import React, { useState } from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { AudioTaskDemonstration } from "../common/AudioTaskDemonstration";
import { TaskDemonstration } from "../common/TaskDemonstration";
import { randomUUID } from "../../../utils";
import { Typography } from "@mui/material";
import { translateReactNode } from "../../../../utils/translateReactNode";

const Definition: AcousticTaskDefinition = {
  name: "Diadochokinesis (v2)",
  cohort: 'generic',

  title: "Diadochokinesis",
  description: "This task helps us analyze the ease and precision of speech sound productions.",
  type: 'acoustic-task',
  estimatedCompletionTime: '1:40',
  subTaskDefinitions: [{
    name: "Diadochokinesis (v2)-puh",
    title: "",
    instructions: <>
      <Typography variant='h5' component='div'>
          Please press the play button to listen to the demonstration on how to complete the task. Then, tap the record button and imitate the speaker by repeating the syllable "puh" as quickly and consistently as possible until the timer runs out - "puhpuhpuhpuhpuhpuh"
        </Typography>
        <TaskDemonstration>
          <Typography variant="h6" component="div">Task Demonstration</Typography>
          <AudioTaskDemonstration audioSrc="assets/audio/DiadochokinesisPuhAudio.mp3" />
        </TaskDemonstration>
      </>,
    profileName: 'speech',
    stopwatchSeconds: 5
  } ,{
    name: "Diadochokinesis (v2)-tuh",
    title: "",
    instructions: <>
      <Typography variant='h5' component='div'>
          Please press the play button to listen to the demonstration on how to complete the task. Then, tap the record button and imitate the speaker by repeating the syllable "tuh" as quickly and consistently as possible until the timer runs out - "tuhtuhtuhtuhtuhtuh"
        </Typography>
        <TaskDemonstration>
          <Typography variant="h6" component="div">Task Demonstration</Typography>
          <AudioTaskDemonstration audioSrc="assets/audio/DiadochokinesisTuhAudio.mp3" />
        </TaskDemonstration>
      </>,
    profileName: 'speech',
    stopwatchSeconds: 5
  }, {
    name: "Diadochokinesis (v2)-kuh",
    title: "",
    instructions: <>
      <Typography variant='h5' component='div'>
          Please press the play button to listen to the demonstration on how to complete the task. Then, tap the record button and imitate the speaker by repeating the syllable "kuh" as quickly and consistently as possible until the timer runs out - "kuhkuhkuhkuhkuhkuh"
        </Typography>
        <TaskDemonstration>
          <Typography variant="h6" component="div">Task Demonstration</Typography>
          <AudioTaskDemonstration audioSrc="assets/audio/DiadochokinesisKuhAudio.mp3" />
        </TaskDemonstration>
      </>,
    profileName: 'speech',
    stopwatchSeconds: 5
  }, {
    name: "Diadochokinesis (v2)-puhtuhkuh",
    title: "",
    instructions: <>
      <Typography variant='h5' component='div'>
          Please press the play button to listen to the demonstration on how to complete the task. Then, tap the record button and imitate the speaker by repeating the syllables "puhtuhkuh" as quickly and consistently as possible until the timer runs out - "puhtuhkuhpuhtuhkuh"
        </Typography>
        <TaskDemonstration>
          <Typography variant="h6" component="div">Task Demonstration</Typography>
          <AudioTaskDemonstration audioSrc="assets/audio/DiadochokinesisPuhtuhkuhAudio.mp3" />
        </TaskDemonstration>
      </>,
    profileName: 'speech',
    stopwatchSeconds: 5
  }, {
    name: "Diadochokinesis (v2)-buttercup",
    title: "",
    instructions: <>
      <Typography variant='h5' component='div'>
          Please press the play button to listen to the demonstration on how to complete the task. Then, tap the record button and imitate the speaker by repeating the word "buttercup" as quickly and consistently as possible until the timer runs out.
        </Typography>
        <TaskDemonstration>
          <Typography variant="h6" component="div">Task Demonstration</Typography>
          <AudioTaskDemonstration audioSrc="assets/audio/DiadochokinesisButtercupAudio.mp3" />
        </TaskDemonstration>
      </>,
    profileName: 'speech',
    stopwatchSeconds: 5
  }]
};
export const DiadochokinesisDefinition = Definition;

// TODO:
// Say the syllables as they appear on your screen – Pa / Ta / Ka.
export const Diadochokinesis =  ({onCompletion}: {onCompletion: () => void}) => {
  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: Definition.subTaskDefinitions.map((definition) => ({
      ...definition,
      id: randomUUID(),
      instructions: translateReactNode(definition.instructions, Definition.cohort),
      title: translateReactNode(definition.title, Definition.cohort) as string
    }))
  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
      />
    </div>
  );
}
